
export const GrupeUtils = {
    validateCreateUserGrupaRequest (createUserGrupeRequest) {
        if (createUserGrupeRequest) {
            const keys = Object.getOwnPropertyNames(createUserGrupeRequest)
            if (keys.indexOf('name') === -1) {
                throw new Error('Missing name attribute on answer object')
            }
        } else {
            throw new Error('no createUserGrupeRequest object')
        }
    },

    validateDeleteUserGrupeRequest (deleteUserGrupeRequest) {
        if (deleteUserGrupeRequest) {
            const keys = Object.getOwnPropertyNames(deleteUserGrupeRequest)
            if (keys.indexOf('groupId') === -1) {
                throw new Error('Missing groupId attribute on deleteUserGrupeRequest object')
            }
        } else {
            throw new Error('no deleteUserGrupeRequest object')
        }
    },

    validateJoinUserGrupeRequest (joinUserGrupeRequest) {
        if (joinUserGrupeRequest) {
            const keys = Object.getOwnPropertyNames(joinUserGrupeRequest)
            if (keys.indexOf('groupId') === -1) {
                throw new Error('Missing groupId attribute on object')
            }
        } else {
            throw new Error('no joinUserGrupeRequest object')
        }
    },

    validateGetAllLeaugeUsersRequest (getAllLeaugeUsersRequest) {
        if (getAllLeaugeUsersRequest) {
            const keys = Object.getOwnPropertyNames(getAllLeaugeUsersRequest)
            if (keys.indexOf('groupId') === -1) {
                throw new Error('Missing groupId attribute on answer object')
            }
        } else {
            throw new Error('no getAllLeaugeUsersRequest object')
        }
    },

    validateRemoveUserFromGrupeRequest (validateRemoveUserFromGrupeRequest) {
        if (validateRemoveUserFromGrupeRequest) {
            const keys = Object.getOwnPropertyNames(validateRemoveUserFromGrupeRequest)
            if (keys.indexOf('groupId') === -1) {
                throw new Error('Missing groupId attribute on answer object')
            }
            if (keys.indexOf('userUid') === -1) {
                throw new Error('Missing userUid attribute on answer object')
            }
        } else {
            throw new Error('no validateRemoveUserFromGrupeRequest object')
        }
    }
}
